'use strict';

var defineComponent = require('flightjs').component;

var xhr = null;

var userSearch = function () {
    this.attributes({
        'apiUrl' : null
    });

    this.doSearch = function (e, query) {
        if (xhr) {
            xhr.abort();
        }

        xhr = $.get(this.attr.apiUrl, {
            q: query,
            newMarkup: true
        });

        xhr.done(function (data) {
            this.trigger('brandContainer.data.userSearch', [data]);
        }.bind(this));
    };

    this.after('initialize', function() {
        this.on('brandContainer.ui.requestUserSearch', this.doSearch);
    });
};

module.exports = defineComponent(userSearch);



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/data/user-search.js
 **/